export default "__VITE_ASSET__B$atedZv__ 720w";